import { SUPPORTED_COMMS_LOCALES } from '@kiku/i18n';

const displayNames = new Intl.DisplayNames(['en'], { type: 'language' });

export const LANGUAGES = SUPPORTED_COMMS_LOCALES.map((code) => ({
  code,
  label: displayNames.of(code) ?? code.toUpperCase()
}));
